<template>
  <div>
    <i
      @click="openHelpModal()"
      data-ts="Button"
      class="ts-icon-info"
      style="font-size: 50px"
    ></i>
    <portal to="asides">
      <help-button-modal />
    </portal>
  </div>
</template>
<style>
#HelpButton {
  bottom: 9px;
  right: 9px;
  position: absolute;
}
</style>
<script>
import $ from 'jquery';
import HelpButtonModal from './HelpButtonModal.vue';

export default {
  components: { HelpButtonModal },
  methods: {
    openHelpModal() {
      const modal = $('#helpButtonModal');
      modal.attr('data-ts.open', true);
    },
  },
};
</script>
